import {
  LIST_DATA_ANALYSIS_REQUEST,
  LIST_DATA_ANALYSIS_SUCCESS,
  LIST_DATA_ANALYSIS_FAIL,
  LIST_DATA_ANALYSIS_CONFIG_LIST_REQUEST,
  LIST_DATA_ANALYSIS_CONFIG_LIST_SUCCESS,
  LIST_DATA_ANALYSIS_CONFIG_LIST_FAIL,
  LIST_DATA_ANALYSIS_PROJECT_REQUEST,
  LIST_DATA_ANALYSIS_PROJECT_SUCCESS,
  LIST_DATA_ANALYSIS_PROJECT_FAIL,
  CREATE_DATA_ANALYSIS_REQUEST,
  CREATE_DATA_ANALYSIS_SUCCESS,
  CREATE_DATA_ANALYSIS_FAIL,
  CREATE_DATA_ANALYSIS_PROJECT_REQUEST,
  CREATE_DATA_ANALYSIS_PROJECT_SUCCESS,
  CREATE_DATA_ANALYSIS_PROJECT_FAIL,
  DETAIL_DATA_ANALYSIS_REQUEST,
  DETAIL_DATA_ANALYSIS_SUCCESS,
  DETAIL_DATA_ANALYSIS_FAIL,
  UPDATE_DATA_ANALYSIS_REQUEST,
  UPDATE_DATA_ANALYSIS_SUCCESS,
  UPDATE_DATA_ANALYSIS_FAIL,
  DELETE_DATA_ANALYSIS_REQUEST,
  DELETE_DATA_ANALYSIS_SUCCESS,
  DELETE_DATA_ANALYSIS_FAIL,
  DELETE_DATA_ANALYSIS_PROJECT_REQUEST,
  DELETE_DATA_ANALYSIS_PROJECT_SUCCESS,
  DELETE_DATA_ANALYSIS_PROJECT_FAIL,
  RESET_DATA_ANALYSIS
} from '../../../../constants/medical-record/analysis/data-analysis'

const initialState = {
  loadingDataAnalysis: false,
  loadingDataAnalysisProject: false,
  loadingDetailDataAnalysis: false,
  loadingAddDataAnalysis: false,
  loadingEditDataAnalysis: false,
  loadingDeleteDataAnalysis: false,
  loadingDeleteDataAnalysisProject: false,
  loadingAddDataAnalysisProject: false,
  loadingDataAnalysisConfigList: false,

  dataAnalysis: [],
  dataAnalysisProject: [],
  dataAnalysisConfigList: [],
  dataAnalysisDetail: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  },
  pageableProject: {
    page: 1,
    size: 10
  }
}

const dataAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_DATA_ANALYSIS_REQUEST:
      return { ...state, loadingDataAnalysis: true }
    case LIST_DATA_ANALYSIS_SUCCESS:
      return {
        ...state,
        loadingDataAnalysis: false,
        dataAnalysis: action.payload,
        pageable: action.pageable
      }
    case LIST_DATA_ANALYSIS_FAIL:
      return {
        ...state,
        loadingDataAnalysis: false,
        error: action.payload
      }
    case LIST_DATA_ANALYSIS_CONFIG_LIST_REQUEST:
      return { ...state, loadingDataAnalysisConfigList: true }
    case LIST_DATA_ANALYSIS_CONFIG_LIST_SUCCESS:
      return {
        ...state,
        loadingDataAnalysisConfigList: false,
        dataAnalysisConfigList: action.payload,
        pageableProject: action.pageable
      }
    case LIST_DATA_ANALYSIS_CONFIG_LIST_FAIL:
      return {
        ...state,
        loadingDataAnalysisConfigList: false,
        error: action.payload
      }
    case LIST_DATA_ANALYSIS_PROJECT_REQUEST:
      return { ...state, loadingDataAnalysisProject: true }
    case LIST_DATA_ANALYSIS_PROJECT_SUCCESS:
      return {
        ...state,
        loadingDataAnalysisProject: false,
        dataAnalysisProject: action.payload,
        pageable: action.pageable
      }
    case LIST_DATA_ANALYSIS_PROJECT_FAIL:
      return {
        ...state,
        loadingDataAnalysisProject: false,
        error: action.payload
      }
    case CREATE_DATA_ANALYSIS_REQUEST:
      return { ...state, loadingAddDataAnalysis: true, error: '' }
    case CREATE_DATA_ANALYSIS_SUCCESS:
      return { ...state, loadingAddDataAnalysis: false }
    case CREATE_DATA_ANALYSIS_FAIL:
      return { ...state, loadingAddDataAnalysis: false, error: action.payload }
    case CREATE_DATA_ANALYSIS_PROJECT_REQUEST:
      return { ...state, loadingAddDataAnalysisProject: true, error: '' }
    case CREATE_DATA_ANALYSIS_PROJECT_SUCCESS:
      return { ...state, loadingAddDataAnalysisProject: false }
    case CREATE_DATA_ANALYSIS_PROJECT_FAIL:
      return {
        ...state,
        loadingAddDataAnalysisProject: false,
        error: action.payload
      }
    case DETAIL_DATA_ANALYSIS_REQUEST:
      return { ...state, loadingDetailDataAnalysis: true }
    case DETAIL_DATA_ANALYSIS_SUCCESS:
      return {
        ...state,
        loadingDetailDataAnalysis: false,
        dataAnalysisDetail: action.payload
      }
    case DETAIL_DATA_ANALYSIS_FAIL:
      return {
        ...state,
        loadingDetailDataAnalysis: false,
        error: action.payload
      }
    case UPDATE_DATA_ANALYSIS_REQUEST:
      return { ...state, loadingEditDataAnalysis: true, error: '' }
    case UPDATE_DATA_ANALYSIS_SUCCESS:
      return { ...state, loadingEditDataAnalysis: false }
    case UPDATE_DATA_ANALYSIS_FAIL:
      return { ...state, loadingEditDataAnalysis: false, error: action.payload }
    case DELETE_DATA_ANALYSIS_REQUEST:
      return { ...state, loadingDeleteDataAnalysis: true, error: '' }
    case DELETE_DATA_ANALYSIS_SUCCESS:
      return { ...state, loadingDeleteDataAnalysis: false, error: '' }
    case DELETE_DATA_ANALYSIS_FAIL:
      return {
        ...state,
        loadingDeleteDataAnalysis: false,
        error: action.payload
      }
    case DELETE_DATA_ANALYSIS_PROJECT_REQUEST:
      return { ...state, loadingDeleteDataAnalysisProject: true, error: '' }
    case DELETE_DATA_ANALYSIS_PROJECT_SUCCESS:
      return { ...state, loadingDeleteDataAnalysisProject: false, error: '' }
    case DELETE_DATA_ANALYSIS_PROJECT_FAIL:
      return {
        ...state,
        loadingDeleteDataAnalysisProject: false,
        error: action.payload
      }
    case RESET_DATA_ANALYSIS:
      return { ...state, ...initialState }
    default:
      return state
  }
}

export default dataAnalysisReducer
